// eslint-disable-next-line no-restricted-imports
import { GQBiQueryFilter } from '../generated/graphql-schema-types';
import { BiChartKind } from '@watershed/constants/bi';

import { BiNormalizedMeasure, BiQueryComponentHashKey } from './types';
import { YMInterval } from '../utils/YearMonth';
import { BiPartialSavedViewState } from './savedViewTypes';
import { SAVED_VIEW_VERSION_V2 } from './savedViewTypesV2';

/**
 * TODO split this up into a union type of BiActivityQueryParams
 * and BiSnapshotQueryParams that extend BiCommonQueryParams
 */
export type BiQueryParams = {
  measures?: Array<BiNormalizedMeasure> | null;
  filters?: Array<GQBiQueryFilter> | null;
  dimensions?: Array<string> | null;
  timeIntervals?: Array<YMInterval> | null;
  view?: string | null;
  chartKind?: BiChartKind | null;
  // footprint specific
  footprintKind?: string | null;
  searchTerm?: string | null;
};

export function makeBiQueryHashParams(
  params: BiQueryParams
): Record<string, string | undefined | null> {
  return {
    [BiQueryComponentHashKey.footprintKind]: getStringifiedOrNull(
      params.footprintKind
    ),
    [BiQueryComponentHashKey.view]: getStringifiedOrNull(params.view),
    [BiQueryComponentHashKey.chartKind]: getStringifiedOrNull(params.chartKind),
    [BiQueryComponentHashKey.filters]: getStringifiedOrNull(params.filters),
    [BiQueryComponentHashKey.dimensions]: getStringifiedOrNull(
      params.dimensions
    ),
    [BiQueryComponentHashKey.measures]: getStringifiedOrNull(params.measures),
    [BiQueryComponentHashKey.intervals]: getStringifiedOrNull(
      params.timeIntervals
    ),
  };
}

/**
 * Convert a V2 saved view state to hash params for use with routeForFootprintBiDrilldown.
 * This is the V2 equivalent of makeBiQueryHashParams.
 */
export function makeBiSavedViewV2HashParams(
  savedView: BiPartialSavedViewState
): Record<string, string | undefined | null> {
  if (savedView.version !== SAVED_VIEW_VERSION_V2) {
    return {};
  }
  const { state } = savedView;
  return {
    [BiQueryComponentHashKey.metricsV2]: getStringifiedOrNull(state.metrics),
    [BiQueryComponentHashKey.dimensionsV2]: getStringifiedOrNull(
      state.dimensions
    ),
    [BiQueryComponentHashKey.filtersV2]: getStringifiedOrNull(state.filters),
    [BiQueryComponentHashKey.intervals]: getStringifiedOrNull(
      state.timeIntervals
    ),
  };
}

export function getStringifiedOrNull(value: unknown): string | null {
  return value != null ? JSON.stringify(value) : null;
}
